export default {
  ACTIVATE_SLEEVE_PRINT: 'canvas/ACTIVATE_SLEEVE_PRINT',
  CHANGE_THRESHOLD: 'canvas/CHANGE_THRESHOLD',
  CHANGE_VIEW: 'canvas/CHANGE_VIEW',
  CLEAR: 'canvas/CLEAR',
  CLEAR_RECENT_UPLOADS: 'canvas/CLEAR_RECENT_UPLOADS',
  DISABLE: 'canvas/DISABLE',
  ICON_RENDERED: 'canvas/ICON_RENDERED',
  REMOVE_RECENT_UPLOAD: 'canvas/REMOVE_RECENT_UPLOAD',
  SET_DISABLE_ARROW_KEYS: 'canvas/SET_DISABLE_ARROW_KEYS',
  SET_LAB_BLANK_LOAD: 'canvas/SET_LAB_BLANK_LOAD',
  SHOW_DESIGN: 'canvas/SHOW_DESIGN'
};
